import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageComposeService } from '../../service/message-compose.service';
import { NgForm } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { AppSettings } from '../../shared/AppSettings';

@Component({
  selector: 'message-compose',
  templateUrl: './message-compose.component.html',
  styleUrls: ['./message-compose.component.css']
})
export class MessageComposeComponent implements OnInit {

  readonly rootUrl = AppSettings.webApiURL; 
  
  message: string = '';
  msgs: Message[] = [];

  recipients: any = [];
  selectedRecipients: any = [];
  filteredRecipients: any = [];
  content: any;
  progressValue: any;
  attachments: any = [];
  isCodeRequired: boolean = false;
  code: string = '';

  constructor(public route: ActivatedRoute, public dataService: MessageComposeService, public router: Router) {
    
    

  }

  searchRecipients(event) {
    let query = event.query;
    this.filteredRecipients = this.filterRecipients(query, this.recipients);
  }


  ngOnInit() {

    this.dataService.InitComposeMessage().subscribe(result => {
    }, 
    (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה באתחול');
    });;

    this.dataService.getRecipients().subscribe(result => {
      this.recipients = result;
      
    }, 
    (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה באתחול נמענים');
    });

    this.initMessage();
  }

  initMessage() {
    this.selectedRecipients = [];
    this.content = '';
    this.isCodeRequired = false;
    this.code = '';
    this.attachments = [];
  }


  onSubmit(f: NgForm) {
    if (f.valid) {
      
    }
  }

  private onBeforeSend(event) {
    this.progressValue = '';
    let userToken = localStorage.getItem('userToken');
    // event.xhr.open("POST", 'http://localhost:34567/api/ComposeMessageApi/upload', true);
    event.xhr.setRequestHeader("Authorization", "Bearer " + userToken);
    event.xhr.withCredentials = true;
  }

  onProgress(event) {
    if (event.originalEvent.loaded !== 0) {
      this.progressValue = Math.round((event.originalEvent.loaded / event.originalEvent.total) * 100).toString() + '%';
    }
  }

  onError(event: any) {
    this.progressValue = '';
    console.log(event);
    this.showMessage('error', '', 'תקלה בהעלאת קובץ');
  }

  onUpload(event) {
    this.progressValue = '';
    this.refreshAttachments();
  }

  refreshAttachments() {
    this.dataService.getAttachments().subscribe(result => {
      this.attachments = result;
      
    }, 
    (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'קלה באיחזור קבצים');
    });
  }


  removeAttachment(attachment) {
    this.dataService.removeAttachment(attachment.Name).subscribe(result => {
      this.refreshAttachments();
      
    }, 
    (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'קלה במחיקת קובץ');
    });
  }

  sendMessage() {
    let valid = true;
    if (this.selectedRecipients == null || this.selectedRecipients.length == 0) {
      valid = false;
      this.showMessage('error', '', 'נא לבחור נמען אחד לפחות');
    }
    if (this.attachments == null || this.attachments.length == 0) {
      valid = false;
      this.showMessage('error', '', 'נא לצרף קובץ אחד לפחות');
    }
    if (this.isCodeRequired && this.code=='') {
      valid = false;
      this.showMessage('error', '', 'נא להזין קוד כאשר דרישת קוד מסומנת');
    }
    if (this.content && this.content.length > 4000) {
      valid = false;
      this.showMessage('error', '', 'תוכן ההודעה לא יכול לעלות מעל 4000 תווים ' + '(תוכן נוכחי - ' + this.content.length.toString() + 'תווים )');
    }
    if (valid) {
        let envelope = { 
                          Recipients: this.selectedRecipients, 
                          Content: this.content, 
                          isCodeRequired: this.isCodeRequired,
                          Code: this.isCodeRequired ? this.code : ''};
        this.dataService.sendMessage(envelope).subscribe(result => {
          this.showMessage('success', '', 'הודעה נשלחה');
          this.ngOnInit();
        }, 
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה באתחול נמענים');
        });
    }

  }





  filterRecipients(query, recipients: any[]):any[] {
    let filtered : any[] = [];
    for(let i = 0; i < recipients.length; i++) {
        let recipient = recipients[i];
        if(recipient.Name.toLowerCase().indexOf(query.toLowerCase()) >= 0 || recipient.EMail.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
            filtered.push(recipient);
        }
    }
    return filtered;
  }


  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/message/message-compose/message-compose.component.ts